import { Button, dialog } from "nq-component";
import CardView from "../../../../components/common/CardView";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import { findObjectUseCase } from "../../../../usecases/object";
import InputFactory from "../../../../components/InputFactory";
import BasePage from "../../../../base/BasePage";
import Hierarchy from "../../../../components/common/Hierarchy";
import HRActionPresenter from "./HRActionPresenter";
import { formattedRate } from "../../../../components/common/Converter";

export default class HRAction extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new HRActionPresenter(this);
    this.state = {
      position: [],
      nonPlantilla: [],
      selectedOffice: "",
      selectedDivision: "",
      actiontype: "",
      selectedPosition: "",
      remarks: "",
      salaryGrade: "",
      step: "",
      salaryPointer: "",
      nonPlantillaSalary: "",
      hierarchy: {},
      positionSelected: {},
      currentSalaryGrade: null,
    };
  }

  async componentDidMount() {
    const { object } = this.props;
    const employmentType = object?.employmentType?.name.toLowerCase().trim();
    const keys = ["name"];

    const promises = [
      findObjectUseCase().execute("position_titles"),
      employmentType === "job order"
        ? findObjectUseCase().execute("non_plantilla")
        : Promise.resolve(null),
      findObjectUseCase().execute("Region", {
        where: { id: object?.region || "undefined" },
        keys: keys,
      }),
      findObjectUseCase().execute("offices", {
        where: { id: object?.office || "undefined" },
        keys: keys,
      }),
      findObjectUseCase().execute("Division", {
        where: { id: object?.division || "undefined" },
        keys: keys,
      }),
      findObjectUseCase().execute("Sections", {
        where: { id: object?.section || "undefined" },
        keys: keys,
      }),
      findObjectUseCase().execute("Units", {
        where: { id: object?.unit || "undefined" },
        keys: keys,
      }),
      findObjectUseCase().execute("Clusters", {
        where: { id: object?.cluster || "undefined" },
        keys: keys,
      }),
      findObjectUseCase().execute("salary_grade", {
        where: {
          salaryCode: object?.salaryCode || "undefined",
        },
        sort: { Year: -1 },
        limit: 1,
      }),
    ];

    const [
      position,
      nonPlantilla,
      region,
      office,
      division,
      section,
      unit,
      cluster,
      salaryGrade,
    ] = await Promise.all(promises);

    // if (nonPlantilla) {
    //   console.log("NONNNN PLANTILLA", nonPlantilla);
    // }
    // console.log("REGION: ", region);
    this.setState({
      position,
      region,
      office,
      division,
      section,
      unit,
      cluster,
      nonPlantilla,
      currentSalaryGrade: salaryGrade?.[0] || null,
    });
  }

  handleFieldChange(field, value) {
    this.setState({ [field]: value });
  }
  handlePositionChange(selectedPosition) {
    this.setState({
      selectedPosition: selectedPosition[0],
      salaryPointer: selectedPosition[1],
      positionSelected: { id: selectedPosition[2] },
    });
  }

  handleNonPlantilla(selectedPosition) {
    this.setState({
      selectedPosition: selectedPosition[0],
      nonPlantillaSalary: selectedPosition[1],
      positionSelected: { id: selectedPosition[2] },
    });
  }

  dialogClose() {
    dialog.close();
  }

  fields = ["region", "office", "division", "section", "unit", "cluster"];
  getLastNonEmptyField = (source) => {
    let result = "";
    let index = -1;

    console.log("this", this.fields);

    this.fields.forEach((field, i) => {
      if (source[field] && source[field] !== "") {
        console.log("source", source[field]);
        result = source[field];
        index = i;
      }
    });

    return { result, index };
  };

  handleObjectChange(hierarchy) {
    this.setState({ hierarchy });
  }
  render() {
    const isMobile = window.innerWidth <= 768;
    const { object } = this.props;
    const {
      region,
      office,
      division,
      section,
      unit,
      cluster,
      salaryPointer,
      currentSalaryGrade,
    } = this.state;

    const employeeName =
      `${object.Firstname || ""} ${object.Middlename || ""} ${
        object.surname || ""
      }` || "-";
    const position = object?.position?.position_title || "-";
    const salaryGrade = currentSalaryGrade
      ? `${currentSalaryGrade.name} (₱ ${formattedRate(
          currentSalaryGrade["Monthly Rate"]
        )} per month)`
      : object?.salaryGrade || "-";
    const step =
      currentSalaryGrade?.Step || object?.salaryPointer?.Step || "-";
    const employmentType = object?.employmentType?.name.toLowerCase().trim();
    const actionTypes = [
      "Renewal",
      "Reappointment",
      "Promotion",
      "Demotion",
      "Re-Classification",
      "Disapproval of appointment",
    ];
    return (
      <div
        className="w-100 h-100 position-fixed end-0 start-0 overflow-y-auto d-flex justify-content-center align-items-center"
        style={{
          zIndex: 1050,
          backgroundColor: "rgba(0, 0, 0, 0.4)",
        }}
      >
        <div
          className="w-100 d-flex column align-items-center"
          style={{
            maxHeight: "99%",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: isMobile ? "90%" : "70%",
            }}
          >
            <CardView style={{ padding: 0 }}>
              <h4 className="fs-6 fw-bold pt-3 ps-3">HR Action</h4>
              <hr />
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  this.presenter.handleClickOk();
                }}
              >
                <div className="row" style={{ padding: "0 1rem" }}>
                  <div className="col-lg-6">
                    <span className="fs-6 fw-bold">Employee Info</span>
                    <table className="table table-bordered rounded mt-3">
                      <thead></thead>
                      <tbody>
                        {[
                          {
                            label: "Employee Name",
                            value: `${employeeName}`,
                          },
                          {
                            label: "OCOM",
                            value: `${
                              region?.length > 0 ? region[0]?.name : "-"
                            }`,
                          },
                          {
                            label: "Location",
                            value: `${
                              office?.length > 0 ? office[0]?.name : "-"
                            }`,
                          },
                          {
                            label: "Region",
                            value: `${
                              division?.length > 0 ? division[0]?.name : "-"
                            }`,
                          },
                          {
                            label: "Subport/ IPEE/ Main RIOU",
                            value: `${
                              section?.length > 0 ? section[0]?.name : "-"
                            }`,
                          },
                          {
                            label: "Division",
                            value: `${unit?.length > 0 ? unit[0]?.name : "-"}`,
                          },
                          {
                            label: "Section/ Unit/ Other Offices",
                            value: `${
                              cluster?.length > 0 ? cluster[0]?.name : "-"
                            }`,
                          },
                          {
                            label: "Position",
                            value: `${position || "-"}`,
                          },
                          {
                            label: "Salary Grade",
                            value: `${salaryGrade}`,
                          },
                          {
                            label: "Step",
                            value: `${step}`,
                          },
                        ].map(({ label, value }) =>
                          this.presenter.tableData(label, value)
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="col-lg-6">
                    <span className="fs-6 fw-bold">HR Action</span>
                    <div className="mt-4 border border-primary border-light">
                      <div className="p-4">
                        <div className="pb-2">
                          <label className="mb-2 fs-6">
                            Action Type <span className="text-danger">*</span>
                          </label>
                          <SearchSelect
                            required
                            value={this.state.actiontype}
                            focus={true}
                            onChange={(value) =>
                              this.handleFieldChange("actiontype", value)
                            }
                            options={actionTypes.map((action) => ({
                              label: action,
                              value: action,
                            }))}
                          />
                        </div>

                        <div className="mb-2 p-0 gap-2">
                          <Hierarchy
                            // object={object}
                            required
                            className="mb-2"
                            handleObjectChange={this.handleObjectChange.bind(
                              this
                            )}
                          />
                        </div>
                        {employmentType === "job order" ? (
                          <div className="pb-2">
                            <label className="mb-2 fs-6">
                              Non Plantilla Position{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <SearchSelect
                              required
                              value={this.state.selectedPosition}
                              focus={true}
                              onChange={this.handleNonPlantilla.bind(this)}
                              options={(this.state.nonPlantilla || []).map(
                                (position) => ({
                                  label: position?.positionTitle,
                                  value: [
                                    position?.positionTitle,
                                    position?.montlhyRate,
                                    position?.id,
                                  ],
                                })
                              )}
                            />
                          </div>
                        ) : (
                          <div className="pb-2">
                            <label className="mb-2 fs-6">
                              Plantilla Position{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <SearchSelect
                              required
                              focus={true}
                              value={this.state.selectedPosition}
                              onChange={this.handlePositionChange.bind(this)}
                              options={this.state.position.map((position) => ({
                                label: position.position_title,
                                value: [
                                  position.position_title,
                                  position.salaryPointer,
                                  position.id,
                                ],
                              }))}
                            />
                          </div>
                        )}

                        <div className="pb-2">
                          <label className="mb-2 fs-6">
                            Effectivity Date{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <InputFactory
                            type="Date"
                            field="effectivityDate"
                            required
                            onChange={(value) =>
                              this.handleFieldChange("effectivityDate", value)
                            }
                          />
                        </div>

                        <div className="pb-2">
                          <label className="mb-2 fs-6">Remarks</label>
                          <InputFactory
                            type="String"
                            _type="textArea"
                            field="remarks"
                            // object={object}
                            onChange={(value) =>
                              this.handleFieldChange("remarks", value)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                  <Button
                    className="btn btn-light fs-sm"
                    type="button"
                    onClick={() => this.props.closeHR()}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn btn-primary"
                    type="submit"
                    progress={this.state.submitting}
                    disabled={this.state.submitting}
                  >
                    OK
                  </Button>
                </div>
              </form>
            </CardView>
          </div>
        </div>
      </div>
    );
  }
}
